module.exports = __webpack_public_path__ + "img/d932352.jpg";